import { msg } from 'gt-react';
import { PresentationChartIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { Route as pathlessAuthenticatedRoute, requireModules } from '../route';

const OrderMetricsDashboard = lazyRouteComponent(
  () => import('./OrderMetricsDashboard'),
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/order-metrics',
  staticData: {
    app: {
      nav: {
        label: msg('Order Metrics', {
          context: 'sidebar nav label, Sales section',
        }),
        icon: <PresentationChartIcon className="h-4 w-4" weight="fill" />,
        group: 'Sales',
        order: 60,
      },
      access: {
        modulesAnyOf: [ProductModule.ORDER_MANAGEMENT],
        featureFlag: 'show-email-po-metrics-enabled',
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SalesOrder },
        ],
      },
    },
  },
  component: OrderMetricsDashboard,
  loader: () => ({
    crumb: msg('Order Metrics', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
  validateSearch: z.object({
    startDate: z.string().optional(),
    endDate: z.string().optional(),
    groupBy: z.enum(['daily', 'weekly', 'monthly']).optional(),
    from: z.string().optional(),
    to: z.string().optional(),
    sources: z.array(z.string()).optional(),
  }),
});
